import React from "react";

const Tabs = ({ tabs, setActiveTab, activeTab }) => {
  return (
    <>
      <div style={{ display: "flex", gap: 16, marginBottom: 24 }}>
        {tabs.map((tab, idx) => (
          <button
            key={tab}
            onClick={() => setActiveTab(idx)}
            style={{
              background: activeTab === idx ? "#bb1ccc" : "#e3e3e3",
              color: activeTab === idx ? "#fff" : "#333",
              border: "none",
              borderRadius: 4,
              padding: "8px 16px",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            {tab}
          </button>
        ))}
      </div>
    </>
  );
};

export default Tabs;